import { ExaminerFunction } from "../pages/Assessment/Assessment.types";

export default interface Examiners {
  examinerId: string;
  examinerNumber: string;
}
export type ExaminerSortBy = 'firstName' | 'lastName' | 'email' | 'pesel' | 'examCommittee' | 'phone' | 'isOnline';

export enum ExaminersType {
  KK,
  KGZ,
  PZE,
  CZE,
  WER,
}

export const getExaminerTypeLabel = (examinerType: ExaminersType) => {
  switch (examinerType) {
    case ExaminersType.KK:
      return `Koordynator Krajowy`;
    case ExaminersType.KGZ:
      return 'Koordynator Grupy Zadań';
    case ExaminersType.CZE:
      return 'Egzaminator';
    case ExaminersType.PZE:
      return 'Przewodniczący Zespołu Egzaminacyjnego';
    case ExaminersType.WER:
      return 'Weryfikator'
  }
};

export const mapExaminerFunctionToType = (examinerFunction: ExaminerFunction): ExaminersType => {
  switch (examinerFunction) {
    case ExaminerFunction.KK:
      return ExaminersType.KK;
    case ExaminerFunction.KGZ:
    case ExaminerFunction.PZWO:
      return ExaminersType.KGZ;
    case ExaminerFunction.PZE:
      return ExaminersType.PZE;
    case ExaminerFunction.CZE:
    case ExaminerFunction.CZWO:
      return ExaminersType.CZE;
    default:
      return ExaminersType.CZE;
  }
};
